import hash from 'object-hash'
import DiffMatchPatch from 'diff-match-patch-fork'

export const diffPatcherConfig = {
  objectHash: function (obj: any) {
    // this function is used only to when objects are not equal by ref
    return obj.id || hash(obj)
  },
  textDiff: {
    // @ts-ignore
    diffMatchPatch: DiffMatchPatch
  }
} as any
